export const brandInfo = {
  name: "6789影视",
  founded: "2020年",
  mission: "让每个人都能享受综艺带来的快乐",
  description: `6789影视成立于2020年，是国内领先的综艺节目在线观看平台。我们致力于为广大综艺爱好者提供最新、最全、最高清的综艺节目资源。

我们的团队由一群热爱综艺的年轻人组成，每天精心筛选和更新优质综艺内容，确保每一位用户都能在这里找到自己喜欢的节目。从搞笑综艺到真人秀，从音乐竞技到脱口秀，6789影视汇集了海量优质综艺资源。

我们始终坚持"免费、高清、流畅"的服务理念，不设任何观看门槛，让综艺的快乐触手可及。经过多年的发展，6789影视已经成为千万用户的首选综艺观看平台。`,
  values: [
    {
      title: "内容丰富",
      description: "涵盖搞笑、真人秀、音乐、脱口秀、竞技、旅行等全品类综艺，满足不同用户的观看需求。",
      icon: "ri-stack-line",
    },
    {
      title: "高清流畅",
      description: "支持1080P高清画质，智能CDN加速技术确保播放流畅不卡顿，带来极致的观看体验。",
      icon: "ri-4k-line",
    },
    {
      title: "每日更新",
      description: "专业编辑团队每日更新最新综艺，让您第一时间看到最热、最新的节目内容。",
      icon: "ri-calendar-check-line",
    },
    {
      title: "完全免费",
      description: "始终坚持免费服务理念，无需会员、无需付费，所有综艺内容免费观看。",
      icon: "ri-vip-crown-line",
    },
  ],
};

export const reputation = [
  {
    name: "张先生",
    avatar: "https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20male%20portrait%20avatar%2C%20warm%20smile%2C%20casual%20style%2C%20clean%20light%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-1-6789&orientation=squarish",
    rating: 5,
    comment: "每天下班必看6789影视，综艺更新速度真的快，画质也很清晰。推荐给身边所有朋友了！",
    date: "2026-07-28",
  },
  {
    name: "李女士",
    avatar: "https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20female%20portrait%20avatar%2C%20gentle%20smile%2C%20elegant%20style%2C%20clean%20light%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-2-6789&orientation=squarish",
    rating: 5,
    comment: "综艺种类很全，想看的基本都能找到。界面简洁没有广告打扰，体验特别好。",
    date: "2026-07-25",
  },
  {
    name: "王同学",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20male%20student%20portrait%20avatar%2C%20bright%20smile%2C%20casual%20style%2C%20clean%20light%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-3-6789&orientation=squarish",
    rating: 5,
    comment: "追综艺的宝藏网站！更新及时，分类清楚，找节目特别方便。强烈推荐给大家！",
    date: "2026-07-22",
  },
  {
    name: "赵女士",
    avatar: "https://readdy.ai/api/search-image?query=A%20Chinese%20female%20professional%20portrait%20avatar%2C%20confident%20smile%2C%20modern%20style%2C%20clean%20light%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-4-6789&orientation=squarish",
    rating: 4,
    comment: "家里老人小孩都喜欢看，综艺内容健康有趣，全家一起看特别欢乐。已经用了两年多了。",
    date: "2026-07-20",
  },
  {
    name: "陈先生",
    avatar: "https://readdy.ai/api/search-image?query=A%20middle-aged%20Chinese%20male%20portrait%20avatar%2C%20friendly%20expression%2C%20business%20casual%20style%2C%20clean%20light%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-5-6789&orientation=squarish",
    rating: 5,
    comment: "6789影视真的是良心平台，免费又高清，不像别的网站到处是广告。忠实粉丝一枚！",
    date: "2026-07-18",
  },
  {
    name: "刘小姐",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20female%20portrait%20avatar%2C%20sweet%20smile%2C%20fashionable%20style%2C%20clean%20light%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-6-6789&orientation=squarish",
    rating: 5,
    comment: "脱口秀大会和吐槽大会一集不落都在这里看的，画质好更新快，超级满意！",
    date: "2026-07-15",
  },
];

export const faqs = [
  {
    question: "6789影视的综艺节目需要付费观看吗？",
    answer: "完全不需要！6789影视始终坚持免费服务理念，所有综艺节目均可免费观看，无需注册会员、无需支付任何费用。我们希望通过免费服务让更多人享受综艺带来的快乐。",
  },
  {
    question: "综艺节目的更新频率是怎样的？",
    answer: "我们拥有专业的编辑团队，每日更新50+部综艺节目。热门综艺在播出后最快2小时内即可上线，确保您不错过任何精彩内容。每日上午10点和晚上8点为集中更新时段。",
  },
  {
    question: "支持哪些设备观看？",
    answer: "6789影视支持电脑、平板、手机等多种设备观看。我们的网站采用响应式设计，自动适配不同屏幕尺寸，无论您使用什么设备都能获得良好的观看体验。",
  },
  {
    question: "视频画质如何？",
    answer: "6789影视提供最高1080P高清画质，并采用智能CDN加速技术，确保播放流畅不卡顿。系统会根据您的网络状况自动调整最佳画质，让观看体验更加顺畅。",
  },
  {
    question: "如何找到我想看的综艺节目？",
    answer: "您可以通过首页的分类导航、搜索功能或者直接浏览各分类页面来查找想看的综艺节目。我们的分类体系清晰明了，涵盖搞笑、真人秀、音乐、脱口秀、竞技、旅行等全品类。",
  },
];

export const contactInfo = {
  email: "contact@6789ys.com",
  wechat: "6789yingshi",
  qq: "1234567890",
  address: "北京市朝阳区建国路88号",
  workingHours: "周一至周日 9:00 - 22:00",
};